import React, { useRef, useState, useEffect } from "react";

/* ── Main Component ── */

const TopBottomImgContent = ({
  section,
  columns = 3,
  align = "center",
  imgHeight = "40vh",
  cardHeight = "13vh",
}) => {
  const [isLg, setIsLg] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsLg(window.innerWidth >= 1024); // lg breakpoint
    };

    handleResize(); // initial check
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { items = [] } = section;
  if (!section) return null;
  return (
    <div className="flex flex-wrap justify-center gap-6">
      {items.map((item, index) => (
        <div
          key={item.id || index}
          className={`w-full 
            sm:basis-[calc(50%-0.75rem)] 
            md:basis-[calc(33.333%-1rem)] 
            ${columns === 5 ? "lg:basis-[calc(20%-1rem)]" : ""}
            ${columns === 4 ? "lg:basis-[calc(25%-1rem)]" : ""}
            ${columns === 3 ? "lg:basis-[calc(33.333%-1rem)]" : ""}
            flex justify-center
          `}
        >
          <ServiceCard
            item={item}
            align={align}
            imgHeight={imgHeight}
            cardHeight={cardHeight}
            isLg={isLg}
          />
        </div>
      ))}
    </div>
  );
};

export default TopBottomImgContent;

/* ── Card Component ── */

const ServiceCard = ({ item, align, imgHeight, cardHeight , isLg}) => {
  const textAlign =
    align === "left"
      ? "text-left items-start"
      : align === "right"
        ? "text-right items-end"
        : "text-center items-center";

  return (
    <div className="bg-white shadow-sm rounded-[10px] rounded-tl-none flex flex-col overflow-hidden w-full max-w-[420px] my-5">
      {/* Image */}
      <div className="relative group">
        <img
          style={{ height: imgHeight }}
          src={item.image}
          alt={item.label || item.title}
          className="w-full h-[28vh] md:h-full  object-cover transition-transform duration-500 group-hover:scale-105"
        />

        {/* ✅ Label ONLY if exists */}
        {item.imgicon && (
          <div className="absolute top-0 left-0 flex items-center gap-2 px-3 py-3 bg-white text-white text-xs rounded-br-[10px]">
            <img src={item.imgicon} alt="" className="" />
            <span>{item.label}</span>
          </div>
        )}
      </div>

      {/* Content */}
      <div
        className="w-full px-4 py-4 bg-[#EAF1FF] flex flex-col justify-center"
        // style={{ height: cardHeight }}
        style={{ height: isLg ? cardHeight : "auto" }}
      >
        {/* <h3
          className="font-semibold mb-2 text-[14px] "
          style={{ color: "var(--primary-color)" }}
        >
          {item.title}
        </h3> */}
        <h4 className="font-semibold mb-2  md:uppercase ">
          {item.title}
        </h4>

        <p className="text-[16px]  leading-relaxed mb-4  ">
          {item.description}
        </p>
      </div>
    </div>
  );
};
